export default "__VITE_ASSET__BppIwtxs__"